
/* vue */
import { ref, unref, defineComponent, reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router'

/* Configs */
import { config } from '@/config/config'

/* Npm Plugins */
import { ElMessage } from 'element-plus';
//import { DocumentEditor, IConfig } from "@onlyoffice/document-editor-vue"
import {  DocumentEditor, IConfig, loadScript } from "@/components/onlyoffice/doc-editor/lib"

/* Hooks & Stores */
import { useAppStore } from '@/store/app'
import { useWatermark } from '@/hooks/useWatermark'

/* Apis */
import { GetPreviewCfgApi, GetHistoryDataApi, GetHistoryInfoApi } from '../../apis/materials/material.api';

export default defineComponent({
    components: { DocumentEditor },
    setup() {

        const { onlyOffice } = config
        const { params } = useRoute()
        const { setWatermark, clear } = useWatermark()
        
        const login = useAppStore().getLoginInfo

        const isConfigLoaded = ref(false);
        const docJsApi = ref<string>(onlyOffice)
        const editorConfig = ref<Nullable<IConfig>>()
        //示例： editorConfig.value = JSON.parse('{"documentType":1,"document":{"title":"测试-DPF.pdf","url":"https://minio.voion.com/attachstore/Contracts/ECT0123060072/9375DB57F00FB207A404FDA84E971128B4BEFF1B.pdf","fileType":"pdf","key":"1f8075c6b8224861ba1b573e4387110b_109089","info":{"owner":"李禄勤(05607)","uploaded":"2024-04-03 18:46:59"},"permissions":{"chat":false,"fillForms":false,"modifyContentControl":true,"userInfoGroups":null,"protect":false,"comment":false,"copy":false,"download":false,"review":true,"print":true,"modifyFilter":false,"edit":false}},"editorConfig":{"mode":"view","lang":"zh-cn","actionLink":"","callbackUrl":"https://contract.voion.com/api/sysmaterial/editorcallback?materialId=a6385842-6dc9-429f-a751-dc54655feb5f&userId=109089&companyId=WYSY","user":{"id":"109089","name":"叶沛明"},"compactHeader":true,"hideNotes":true,"macros":false,"customization":{}},"height":"100%","width":"100%","type":"desktop","token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudFR5cGUiOjEsImRvY3VtZW50Ijp7InRpdGxlIjoi5rWL6K-VLURQRi5wZGYiLCJ1cmwiOiJodHRwczovL21pbmlvLnZvaW9uLmNvbS9hdHRhY2hzdG9yZS9Db250cmFjdHMvRUNUMDEyMzA2MDA3Mi85Mzc1REI1N0YwMEZCMjA3QTQwNEZEQTg0RTk3MTEyOEI0QkVGRjFCLnBkZiIsImZpbGVUeXBlIjoicGRmIiwia2V5IjoiMWY4MDc1YzZiODIyNDg2MWJhMWI1NzNlNDM4NzExMGJfMTA5MDg5IiwiaW5mbyI6eyJvd25lciI6IuadjuemhOWLpCgwNTYwNykiLCJ1cGxvYWRlZCI6IjIwMjQtMDQtMDNUMTg6NDY6NTkuOTQifSwicGVybWlzc2lvbnMiOnsiY2hhdCI6ZmFsc2UsImZpbGxGb3JtcyI6ZmFsc2UsIm1vZGlmeUNvbnRlbnRDb250cm9sIjp0cnVlLCJ1c2VySW5mb0dyb3VwcyI6bnVsbCwicHJvdGVjdCI6ZmFsc2UsImNvbW1lbnQiOmZhbHNlLCJjb3B5IjpmYWxzZSwiZG93bmxvYWQiOmZhbHNlLCJyZXZpZXciOnRydWUsInByaW50Ijp0cnVlLCJtb2RpZnlGaWx0ZXIiOmZhbHNlLCJlZGl0IjpmYWxzZX19LCJlZGl0b3JDb25maWciOnsibW9kZSI6InZpZXciLCJsYW5nIjoiemgtY24iLCJhY3Rpb25MaW5rIjoiIiwiY2FsbGJhY2tVcmwiOiJodHRwczovL2NvbnRyYWN0LnZvaW9uLmNvbS9hcGkvc3lzbWF0ZXJpYWwvZWRpdG9yY2FsbGJhY2s_bWF0ZXJpYWxJZD1hNjM4NTg0Mi02ZGM5LTQyOWYtYTc1MS1kYzU0NjU1ZmViNWYmdXNlcklkPTEwOTA4OSZjb21wYW55SWQ9V1lTWSIsInVzZXIiOnsiaWQiOiIxMDkwODkiLCJuYW1lIjoi5Y-25rKb5piOIn0sImNvbXBhY3RIZWFkZXIiOnRydWUsImhpZGVOb3RlcyI6dHJ1ZSwibWFjcm9zIjpmYWxzZSwiY3VzdG9taXphdGlvbiI6e319LCJoZWlnaHQiOiIxMDAlIiwid2lkdGgiOiIxMDAlIiwidHlwZSI6ImRlc2t0b3AiLCJleHAiOjE3MTIzODE2ODIsImlhdCI6MTcxMjM3ODA4MiwibmJmIjoxNzEyMzc4MDgyfQ.2CStHLB2I_e0bStlLHNWhZ0dL5-wnj5fhI5DWaiPWAE"}');

        const state = reactive({
            historyInfoList: [],
            historyDataList: []
        })

        /* 读取Editor编辑器配置 */
        async function loadingConfig(rotId: string, deviceType: number, func: any) {
            const res = await GetPreviewCfgApi({ material_id: rotId, device: deviceType })
            if (!res.succeeded) {
                ElMessage.error(`读取文档失败，可能的原因是：${res.errors}`)
            } else {
                console.log('读取Editor编辑器配置-1', res.data);
                editorConfig.value = res.data as IConfig;

                const hisListRes = await GetHistoryDataApi(rotId)
                const hisDataRes = await GetHistoryInfoApi(rotId, 0)

                state.historyInfoList = hisListRes.data || null
                state.historyDataList = hisDataRes.data || null

                isConfigLoaded.value = true;
                func && func(unref(editorConfig)!);
            }
        }

        /* Editor方法集合 */
        const methods = {
            onAppReady: (docEditor: any) => {
                console.log('DocViewNew.vue onAppReady => docEditor',  docEditor)
                console.log('DocViewNew.vue onAppReady => window.DocsAPI',  window.DocsAPI)     
                console.log('DocViewNew.vue onAppReady => window.DocEditor',  window.DocEditor)
                   
                /* 添加水印 */
                setWatermark(`${login.user_name}(${login.user_account})`)
            },
            
            requestHistory: async (events: any, pr: any) => {
                const editors = window.DocEditor?.instances.docEditor
                if (editors) {
                    editors.refreshHistory(state.historyInfoList)
                }
            },

            requestHistoryData: async (events: any) => {
                const version = events.data
                const historyData = state.historyDataList[version - 1]

                const editors = window.DocEditor?.instances.docEditor

                if (editors && historyData) {
                    editors.setHistoryData(historyData)
                }
            },

            onHistoryClosed: () => {
                document.location.reload();
            },
            
            onInfo: (info: any) => {
                console.log('onInfo', info)
            },

            onWarning: (warning: any) => {
                console.log('onWarning', warning)
            },

            onError: (error: any) => {
                console.log('onError', error)
            },
        }

        onMounted(() => {
            console.log('DocViewNew.vue onMounted')
			const materialId = params.fileId as string;
			const deviceType = parseInt(params.device as string);
            //loadingConfig(materialId, deviceType, null);

            var docApiUrl = "".concat(docJsApi.value, "/web-apps/apps/api/documents/api.js");
            loadScript(docApiUrl, "onlyoffice-api-script")
                .then(function (e: any) { 
                    console.log('loadScript.then', e)
                    loadingConfig(materialId, deviceType, (editorConfig: IConfig) =>{
                        console.log('DocViewNew.vue loadingConfig => editorConfig',  editorConfig);
                        console.log('DocViewNew.vue loadingConfig => window.DocsAPI',  window.DocsAPI)
                        console.log('DocViewNew.vue loadingConfig => window.DocEditor',  window.DocEditor)
                        
                        const instance = new window.DocsAPI.DocEditor('onlyoffice', editorConfig);
                        console.log('DocViewNew.vue loadingConfig => DocEditor instance', instance);

                        /* 添加水印 */
                        setWatermark(`${login.user_name}(${login.user_account})`)
                    });                    
                })
                .catch(function (e: any) { 
                    console.log('loadScript.catch', e)
                }
            );
        })

        /* 监听窗口关闭事件，并在关闭时销毁 DocumentEditor对象 */
        window.addEventListener('beforeunload', function () {
            const editors = window.DocEditor?.instances.docEditor
            if (editors) {
                editors.destroyEditor()
            }
            clear() // 清除水印
        });

        // return () => (
        //     <div style="width:100%; height:100%">
        //         {!unref(isConfigLoaded) ?
        //             (<div v-loading="true" element-loading-text="正在加载文档，请稍后" element-loading-background="rgba(122, 122, 122, 0.3)" style="width:100%; height:100%"></div>)
        //             : (<DocumentEditor id="docEditor" type='mobile'
        //                 documentServerUrl={unref(docJsApi)}
        //                 config={unref(editorConfig)!}
        //                 events_onAppReady={methods.onAppReady}
        //                 events_onRequestHistoryClose={methods.onHistoryClosed}
        //                 events_onRequestHistory={methods.requestHistory}
        //                 events_onRequestHistoryData={methods.requestHistoryData}
        //                 events_onInfo={methods.onInfo}
        //                 events_onWarning={methods.onWarning}
        //                 events_onError={methods.onError}
        //             />)
        //         }
        //     </div>
        // )
        
    },
})

